import React, { FC, useEffect, useState } from "react";
import { Container } from "reactstrap";
import AEABreadcrumb from "../../components/ux/aea-breadcrumb/aea-breadcrumb";
import { MainLayoutPresenter } from "../../presenters/containers/main-layout.presenter";
import { TopBar, DetailAccount, AEALoader } from "../../components";
import { UncontrolledCollapse, Col } from "reactstrap";
import styles from "./main-layout.module.scss";
import NavBar from '../../components/ux/navbar/navbar.component'
import { NavigationPresenter } from '@presenters/ux/navbar.presenter';
import { INavigation } from '@interfaces/ux/navigation.interface';
import SPFileService from "@services/base/sp-file.service";
import { AuthPresenter } from "@presenters/containers/auth.presenter";

const translations = {
  ES: {
    lastUpdate: "Última actualización del aplicativo: 23/05/2022",
    infoMessage: "Sí no estás viendo la información completa o actualizada, por favor presiona 3 veces continuas CTRL + SHIFT + R"
  },
  EN: {
    lastUpdate: "Last update of the application: 05/23/2022",
    infoMessage: "If you're not seeing the full or updated information, please press CTRL + SHIFT + R three times continuously"
  }
};

const MainLayout: FC = (props) => {
  const [navbarItems, setNavbarItems] = useState([]);
  const [logo, setLogo] = useState('/AEA-logo.png');
  const [applicationName, setApplicationName] = useState('');
  const [user, setUser] = useState(null);
  const [userImage, setUserImage] = useState(null);
  const [translatedTexts, setTranslatedTexts] = useState(translations.ES); // Estado para las traducciones

  const navigationData: INavigation = {
    state: {
      navbarItems: navbarItems,
      setNavbarItems: setNavbarItems,
      logo: logo,
      setLogo: setLogo
    }
  };

  const authPresenter = new AuthPresenter();
  const presenter = new MainLayoutPresenter({});
  const navigationPresenter = new NavigationPresenter(navigationData);
  const helpFileService = new SPFileService();

  presenter.initializeLanguage();

  useEffect(() => {
    presenter.dispatchMainStates();
  }, []);

  useEffect(() => {
    navigationPresenter.getNavBarItems();
    const currentLang = navigationPresenter.getCurrentLang().label || 'ES';
    if (currentLang === 'EN' || currentLang === 'ES') {
      setTranslatedTexts(translations[currentLang]);
    } else {
      setTranslatedTexts(translations.ES);
    }
  }, []);

  useEffect(() => {
    setUser(navigationPresenter.getUser());
  }, [navigationPresenter.currentUser]);
  
  useEffect(() => {
    const getUserPhoto = async () => { 
      if (user?.email) {
        const userPhotoBlob = await authPresenter.getUserPhoto(user.email);

        if (userPhotoBlob) {
          const imageUrl = URL.createObjectURL(userPhotoBlob);
          setUserImage(imageUrl);
        }
      }
    }

    getUserPhoto();
  }, [user]);

  useEffect(() => {
    const currentPath = window.location.pathname.toLowerCase();
    if (currentPath.startsWith('/admin')) {
      setApplicationName('ADMINISTRACIÓN GLOBAL');
    } else if (currentPath.startsWith('/proyecta')) {
      setApplicationName('PROYECTA');
    }
  }, []);

  useEffect(() => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  }, []);

  const getSubMenuItems = async (listName: string) => {
    return await navigationPresenter.getSubMenuItems(listName)
  }

  return (
    <div>
      <NavBar
        applicationName={applicationName}
        navbarItems={navbarItems}
        currentSiteUrl={navigationPresenter.getRoot()}
        urlLogo={logo}
        langs={navigationPresenter.getLangs()}
        currentLang={navigationPresenter.getCurrentLang()}
        onLanguageChange={navigationPresenter.setLang}
        user={user}
        userImage={userImage}
        filterGroups={(item: any) => item.name?.toLowerCase()?.startsWith('proyecta')}
        proyectaFilter={(x: any) => (x?.OCTAVIAUrl?.includes('followupAdmin') || x?.OCTAVIAUrl?.includes('popAdmin')) ? navigationPresenter.getTotalPermissions() : true}
        routeHelpVisor="/proyecta/user_help"
        getHelpFiles={helpFileService.getApplicationHelpFiles}
        fetchSubMenuItems={getSubMenuItems}
      />
      
      {/* Antiguo Navbar */}
      {/* <TopBar></TopBar>
      <UncontrolledCollapse toggler="#toggler-datail-account">
        <Col xs={12} md={5} lg={4} className={styles.accountDetailContainer}>
          <DetailAccount></DetailAccount>
        </Col>
      </UncontrolledCollapse> */}
      
      <Container
        fluid={true}
        className=" p-md-3"
        style={{ display: presenter.isLoadingContainer ? "none" : "block" }}
      >
        <p className={styles.alertMsgDate}>
          {translatedTexts.lastUpdate}
        </p>
        <p className={styles.alertMsg}>
          {translatedTexts.infoMessage}
        </p>

        <AEABreadcrumb></AEABreadcrumb>

        {props.children}
      </Container>
      <AEALoader
        style={{ display: presenter.isLoadingContainer ? "block" : "none" }}
        progress={presenter.progress}
        pendingLoad={presenter.pendingLoad}
      ></AEALoader>
    </div>
  );
};

export default MainLayout;
